import React, { useState } from 'react';
import PropTypes from 'prop-types';

import LanguageConverter from '@careerstart/wae-common/src/main/helperFunction/LanguageConverter';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';

import { PRIMARY_PURPLE } from '../../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../../theme/fontConstants';
import { capitalizeFirstLetter } from '../../../UsersHelpers';

import SectionCard from './SectionCard';
import WorkExperienceModal from './WorkExperienceModal';

const styles = {
  subHeaderStyle: {
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[500],
    my: 0.5,
  },
  textStyle: {
    fontSize: '16px',
  },
  underlineStyle: {
    color: PRIMARY_PURPLE[70],
    textDecoration: 'underline',
    fontSize: '16px',
  },
};

/* eslint-disable react/no-array-index-key */
const WorkExperienceCard = ({ industries = [], selectedUserId }) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box data-testid="work-experience-card">
      <SectionCard header={LanguageConverter('userDetail.experience.header')}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          {industries?.length > 0 ? (
            <Typography sx={styles.subHeaderStyle}>
              {LanguageConverter('userDetail.experience.industrySelected')}
            </Typography>
          ) : (
            <Typography sx={styles.subHeaderStyle}>
              {LanguageConverter('userDetail.experience.noSelectedIndustry')}
            </Typography>
          )}
          <Typography onClick={handleOpen} sx={styles.underlineStyle}>
            {LanguageConverter('userDetail.experience.seeExperience')}
          </Typography>
        </Box>
        {industries?.map((industryName, index) => (
          <Typography key={index} sx={styles.textStyle} data-testid="industry-name">
            {capitalizeFirstLetter(industryName)}
          </Typography>
        ))}
      </SectionCard>
      {open && <WorkExperienceModal onClose={handleClose} selectedUserId={selectedUserId} />}
    </Box>
  );
};

WorkExperienceCard.propTypes = {
  industries: PropTypes.arrayOf(PropTypes.string),
  selectedUserId: PropTypes.string.isRequired,
};

export default WorkExperienceCard;
